import { Box, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { Fund } from '../../api/useFunds';
import { FundAutocompleteMobile } from './FundAutocompleteMobile';
import { FundAutocomplete } from './FundAutocomplete';

type FundAutocompleteSectionProps = {
  fundsMap: Map<Fund, number>;
  onClearAll: () => void;
  onFundSelect: (fund: Fund) => void;
  onAddFundClick: () => void;
};

export const FundAutocompleteSection = ({
  fundsMap,
  onClearAll,
  onFundSelect,
  onAddFundClick,
}: FundAutocompleteSectionProps) => {
  const theme = useTheme();
  const isLessMd = useMediaQuery(theme.breakpoints.down('md'));

  if (isLessMd) {
    return (
      <FundAutocompleteMobile
        areFundsSelected={fundsMap.size > 0}
        onClick={onAddFundClick}
        onClearAll={onClearAll}
      />
    );
  }

  return (
    <Box
      sx={{
        padding: theme.spacing(5, 0, 6),
      }}
    >
      <FundAutocomplete
        id="fund-autocomplete"
        autocompleteKey={fundsMap.size.toString()} // this will clear the autocomplete once the length changes
        onChange={onFundSelect}
        areFundsSelected={fundsMap.size > 0}
        onClearAll={onClearAll}
      />
    </Box>
  );
};
